import { Button } from 'primereact/button';
import { FC } from 'react';
import { createAndExportCSV } from '../../businessLogicService/createAndExportGenericCSV';
import { format } from 'date-fns';
import { Download } from 'lucide-react';

interface Filters {
  sortOrder: 1 | -1 | 0;
  sortField: string;
  searchTerm?: string | null;
}

export interface DownloadData {
  [key: string]: string | boolean | Date | null;
  name: string;
  firstName: string;
  lastName: string;
  status: string;
  date: Date | null;
  timeSpent: string;
  reset: boolean;
  demonstrated: string;
  projectedTwo: string;
  projectedThree: string;
}

interface Props {
  studentList: DownloadData[];
  filters: Filters;
}

export const DiagnosticReportDownloadCSV: FC<Props> = ({ studentList, filters }) => {
  const changeLabelFromBackendEnum = (status: string) => {
    if (status === 'AT_RISK') {
      return 'APPROACHING';
    } else {
      return status;
    }
  };
  const headers = [
    'First Name',
    'Last Name',
    'Status',
    'Date Completed',
    'Time Spent',
    'Reset',
    'Demonstrated Skills',
    'Projected status 2 skills / week',
    'Projected status 3 skills / week',
  ];
  const rows: string[][] = studentList
    ?.filter(std => {
      return std.name?.toLowerCase().includes(filters?.searchTerm?.toLowerCase() || '');
    })
    .sort((a, b) => {
      const _a = a[filters.sortField];
      const _b = b[filters.sortField];
      if (_a && _b) {
        if (_a > _b) {
          return filters.sortOrder;
        } else {
          return filters.sortOrder * -1;
        }
      } else {
        return 0;
      }
    })
    .map(st => {
      const objProps: string[] = Object.values({
        firstName: String(st.firstName),
        lastName: String(st.lastName),
        status: st.status,
        date: st.date ? format(new Date(st.date as Date), 'P') : '',
        timeSpent: st.timeSpent ? String(st.timeSpent) + 'm' : '',
        reset: st.reset ? 'Yes' : '',
        demonstrated: st.demonstrated ? String(st.demonstrated) : '',
        projectedTwo: st.projectedTwo ? String(changeLabelFromBackendEnum(st.projectedTwo)) : '',
        projectedThree: st.projectedThree ? String(changeLabelFromBackendEnum(st.projectedThree)) : '',
      });
      return [...objProps];
    });

  return (
    <Button
      id="dgDownloadReport"
      disabled={!studentList.length}
      onClick={() => {
        createAndExportCSV(headers, rows);
      }}
      icon={<Download size={20} />}
      label="Download results"
      className="tw-flex tw-flex-row tw-gap-x-2 tw-flex-row-reverse tw-w-1/2"
    />
  );
};
